.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.spinner > div {
  width: 12px;
  height: 12px;
  background-color: var(--primary);
  border-radius: 100%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  animation-delay: -0.16s;
}

.small > div {
  width: 8px;
  height: 8px;
}

.medium > div {
  width: 12px;
  height: 12px;
}

.large > div {
  width: 16px;
  height: 16px;
}

.primary > div {
  background-color: var(--primary);
}

.light > div {
  background-color: var(--white);
}

.dark > div {
  background-color: var(--gray-800);
}

.centered {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
}

@keyframes bounce {
  0%, 80%, 100% { 
    transform: scale(0);
  } 
  40% { 
    transform: scale(1.0);
  }
}
